import {
    FETCH_PERSONAL_RECORD_TYPES,
    FETCH_PERSONAL_RECORD_TYPES_FETCHING,
    FETCH_PERSONAL_RECORD_TYPES_SUCCESS,
    FETCH_PERSONAL_RECORD_TYPES_FAIL,
    UPDATE_PERSONAL_RECORD_TYPE
} from 'actions/ActionTypes.js';
import { filterTypes, PersonalRecordTabTypes } from 'utils/PersonalRecordsUtil';
const INITIAL_STATE = {
    data: [],
    filteredPersonalRecordsTypes: null,
    personalRecordTypesFetching: false,
    personalRecordTypesFetchFail: false
};

// ======= Fetching Handlers =======
const fetchPersonalRecordTypesFetching = (state, action) => {
    return {
        ...state,
        personalRecordTypesFetching: true,
        personalRecordTypesFetchFail: false
    };
};

const fetchPersonalRecordTypesSuccess = (state, action) => {
    const personalRecordsTypesKeys = Object.keys(PersonalRecordTabTypes);
    const filteredPersonalRecordsTypes = Object.fromEntries(
        personalRecordsTypesKeys.map((key) => [key, filterTypes(key, action.data)])
    );

    return {
        ...state,
        data: [...action.data],
        filteredPersonalRecordsTypes: filteredPersonalRecordsTypes,
        personalRecordTypesFetching: false,
        personalRecordTypesFetchFail: false
    };
};

const fetchPersonalRecordTypesFail = (state, action) => {
    return {
        ...state,
        personalRecordTypesFetching: false,
        personalRecordTypesFetchFail: true
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_PERSONAL_RECORD_TYPES_FETCHING]: fetchPersonalRecordTypesFetching,
    [FETCH_PERSONAL_RECORD_TYPES_SUCCESS]: fetchPersonalRecordTypesSuccess,
    [FETCH_PERSONAL_RECORD_TYPES_FAIL]: fetchPersonalRecordTypesFail
};

// ======= Default Action ======
export default function personalRecordTypes(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchPersonalRecordTypes(displayName, evictCache) {
    return {
        displayName: displayName,
        type: FETCH_PERSONAL_RECORD_TYPES,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function updatePersonalRecordType(recordType, displayName) {
    return {
        displayName,
        recordType,
        type: UPDATE_PERSONAL_RECORD_TYPE
    };
}

export const getPersonalRecordTypes = (state) => {
    return state.personalRecordTypes.data ? state.personalRecordTypes.data : null;
};

export const getFilteredPersonalRecordTypes = (state) => {
    return state.personalRecordTypes.filteredPersonalRecordsTypes
        ? state.personalRecordTypes.filteredPersonalRecordsTypes
        : null;
};

export const isPersonalRecordTypesFetching = (state) => {
    return state.personalRecordTypes.personalRecordTypesFetching;
};

export const isPersonalRecordTypesSuccess = (state) => {
    return state.personalRecordTypes.personalRecordTypesFetchFail === false;
};
